// Carry Roll ObstacleCheck — does the trajectory clear a tree/obstacle (emergent TODO-12).

import { useState } from 'react';
import { Check, X } from 'lucide-react';
import { ExpressionInput } from 'calc-controls';
import { useStore } from '../../store';
import { useResult } from '../../store/selectors';
import { obstacleCheck } from '@carry-roll/shared-logic';
import { distanceToM, heightToM } from '@carry-roll/shared-logic';
import { HelpTooltip } from './HelpTooltip';

export function ObstacleCheck() {
  const result = useResult();
  const distanceUnit = useStore((s) => s.distanceUnit);
  const heightUnit = useStore((s) => s.heightUnit);
  const [dist, setDist] = useState(0);
  const [height, setHeight] = useState(0);

  const obstacleM = dist > 0 ? distanceToM(dist, distanceUnit) : null;
  const obstacleHeightM = height > 0 ? heightToM(height, heightUnit) : null;
  const check =
    obstacleM != null && obstacleHeightM != null
      ? obstacleCheck(result.flightPath, obstacleM, obstacleHeightM)
      : null;

  return (
    <div data-testid="obstacle-check" className="flex items-center gap-2 flex-wrap">
      <span className="text-xs inline-flex items-center" style={{ color: 'var(--color-text-muted)' }}>
        Obstacle at:
        <HelpTooltip label="Obstacle check">Checks whether the trajectory clears an obstacle (e.g. a tree) of the given height at the given distance. CLEAR is shown when the flight path is above it.</HelpTooltip>
      </span>
      <ExpressionInput
        inline
        value={dist}
        onChange={setDist}
        unit={distanceUnit}
        aria-label="Obstacle distance"
        decimals={0}
        min={0}
      />
      <span className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
        height
      </span>
      <ExpressionInput
        inline
        value={height}
        onChange={setHeight}
        unit={heightUnit}
        aria-label="Obstacle height"
        decimals={0}
        min={0}
      />
      {check && (
        <span
          className={`badge ${check.pass ? 'badge-success' : 'badge-danger'}`}
          role="status"
        >
          {check.pass ? (
            <>
              <Check size={12} aria-hidden="true" style={{ verticalAlign: 'middle' }} /> CLEAR
            </>
          ) : (
            <>
              <X size={12} aria-hidden="true" style={{ verticalAlign: 'middle' }} /> SHORT
            </>
          )}{' '}
          by {Math.abs(check.clearanceM).toFixed(1)} m
        </span>
      )}
    </div>
  );
}
